<nz-collapse [nzBordered]="false" nzGhost>
  <nz-collapse-panel
    #userPanel
    class="collapse-panel"
    [nzHeader]="qualificationAttachmentSectionHeader"
    [nzActive]="
      !canReadUserQualificationV2Attachments
        ? false
        : userQualificationAttachments &&
            userQualificationAttachments.length > 0
          ? true
          : false
    "
    [nzCollapsible]="
      (
        !canReadUserQualificationV2Attachments
          ? true
          : userQualificationAttachments &&
              userQualificationAttachments.length > 0
            ? false
            : true
      )
        ? 'disabled'
        : undefined
    "
    [nzShowArrow]="true"
    nz-tooltip
    [nzTooltipTitle]="'general.no_permissions' | translate"
    [nzTooltipTrigger]="
      canReadUserQualificationV2Attachments === false ? 'hover' : null
    "
  >
    <div class="details-grid">
      @for (attachment of userQualificationAttachments; track attachment) {
        <div class="info-row">
          <a class="info-label" [href]="attachment.s3Path" target="_blank">
            <fa-icon [icon]="faPaperClip"></fa-icon>
            {{ attachment.fileName }}
          </a>
          <span class="info-value attachment-date">
            {{ attachment.createdAt | dfnsParseIso | localizedDateFormat }}
          </span>
        </div>
      }
    </div>
  </nz-collapse-panel>

  <ng-template #qualificationInfoSectionHeader>
    <div class="d-flex justify-content-between">
      <span class="header-text">
        {{ 'general.title' | translate }}
      </span>
    </div>
  </ng-template>
  <ng-template #qualificationAttachmentSectionHeader>
    <div class="d-flex justify-content-between">
      <span class="header-text">
        {{ 'general.attachments' | translate }}
      </span>
    </div>
  </ng-template>
</nz-collapse>
